import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { AuthRoute, Switch, Redirect } from '@fs/zion-router'
import { usePageTitle } from '../../app/PageTitleContext'
import RftQueryResults from './RftQueryResults'
import RftResultsPreview from './RftResultsPreview'
import { RftContextProvider } from './RftContext'

import useRftQueries from './useRftQueries'

export default function RftBase({ match }) {
  usePageView({ page_detail: 'DMConsole:RftBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tools.rftQueries'))
  const { state, dispatch } = useRftQueries()
  return (
    <RftContextProvider value={{ state, dispatch }}>
      <Switch>
        <Redirect exact from={`${match.path}`} to={`${match.path}/queries`} />
        <AuthRoute exact path={`${match.path}/queries`} component={RftQueryResults} />
        <AuthRoute exact path={`${match.path}/queries/:jobId`} component={RftResultsPreview} />
      </Switch>
    </RftContextProvider>
  )
}
